import React, { ReactNode } from 'react';
import { CopyType, Tool } from '../../../store//types/prescription';
import { GeniePadElementsSettingItem } from '../../../api/pushGenie';
import {
    currentMedicationsCopyIcon,
    filesCopyIcons,
    injectionsIcon,
    medicationsIcon,
} from '../../../components/common/Icons';
import { AntTooltip } from '../../../components/common/AntTooltip';
import { Dropdown, Menu } from 'antd';

export type P = {
    visit: Tool & { date: string; visitId: string };
    padElementsConfig: GeniePadElementsSettingItem[];
};

const smallCopyIcon = filesCopyIcons('w-10 h-10');

export const Wrapper: React.FC<{
    iconCssClass: string;
    iconText?: JSX.Element | string;
    content: ReactNode;
    onCopy?: (type?: CopyType) => void;
    iconTooltipContent: ReactNode;
    isWholeBodyCopy?: boolean;
    id?: string;
}> = ({
    iconCssClass,
    iconText,
    content,
    onCopy,
    iconTooltipContent,
    isWholeBodyCopy: isWholeBodyCopy = true,
    id,
}) => {
    if (!content) {
        return null;
    }
    const isMedications = id === 'medications';
    const isInjections = id === 'injections';

    return (
        <div
            onClick={isWholeBodyCopy ? (e) => onCopy?.() : undefined}
            className={`p-5 flex space-x-8 font-400 ${iconText ? 'magicbox-pastvisit' : ''}`}
        >
            {iconText && (
                <AntTooltip placement="top" content={iconTooltipContent}>
                    <p
                        className={`w-24 h-24 flex justify-center items-center text-12 font-700 ${iconCssClass} rounded-full`}
                    >
                        {iconText}
                    </p>
                </AntTooltip>
            )}
            <div className="flex-1 space-y-9">{content}</div>
            {onCopy &&
                (isMedications || isInjections ? (
                    <Dropdown
                        trigger={['click']}
                        destroyPopupOnHide
                        placement="bottomRight"
                        getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLDivElement}
                        overlay={
                            <Menu className="group">
                                <MenuItem
                                    onCopy={onCopy}
                                    type={CopyType[isInjections ? 'INJ' : 'MX']}
                                />
                                <MenuItem onCopy={onCopy} type={CopyType.CurrentMX} />
                            </Menu>
                        }
                    >
                        <span
                            onClick={(e) => e.stopPropagation()}
                            className="h-28 w-28 flex justify-center cursor-pointer items-center bg-white svg border border-darwin-primary-500 rounded-4 group-hover:flex"
                        >
                            {smallCopyIcon}
                        </span>
                    </Dropdown>
                ) : (
                    <span
                        onClick={isWholeBodyCopy ? undefined : (e) => onCopy()}
                        className="h-28 w-28 flex justify-center cursor-pointer items-center bg-white svg border border-darwin-primary-500 rounded-4"
                    >
                        {smallCopyIcon}
                    </span>
                ))}
        </div>
    );
};

const MenuItem = ({ onCopy, type }: { onCopy: (type?: CopyType) => void; type: CopyType }) => {
    const MAP = {
        MX: {
            text: 'Copy to medications',
            icon: medicationsIcon,
        },
        CurrentMX: {
            text: 'Copy to medical history',
            icon: currentMedicationsCopyIcon,
        },
        INJ: {
            text: 'Copy to injections',
            icon: injectionsIcon,
        },
    };

    return (
        <Menu.Item
            onClick={(e) => {
                e.domEvent.stopPropagation();
                onCopy(type);
            }}
            className="px-16 py-10"
        >
            <span style={{ gap: 8 }} className="flex flex-row items-center justify-start">
                {MAP[type].icon()}
                <p>{MAP[type].text}</p>
            </span>
        </Menu.Item>
    );
};
export default Wrapper;
